module.exports = __webpack_public_path__ + "static/media/circle-down-arrow.f03364e6.svg";